/* tslint:disable */
/* eslint-disable */
/**
 * Citrus API Reference
 * Complete reference documentation for the Citrus API.
 *
 * The version of the OpenAPI document: 0.112.0
 * Contact: info@citruscamps.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    Restrictions,
    RestrictionsFromJSON,
    RestrictionsFromJSONTyped,
    RestrictionsToJSON,
} from './Restrictions';
import {
    RestrictionsMinimumAmount,
    RestrictionsMinimumAmountFromJSON,
    RestrictionsMinimumAmountFromJSONTyped,
    RestrictionsMinimumAmountToJSON,
} from './RestrictionsMinimumAmount';

/**
 * Settings that restrict the redemption of the promotion code.
 * @export
 * @interface CouponRestrictions
 */
export interface CouponRestrictions {
    /**
     * A value indicating if the coupon should only be redeemed for customers without any past orders.
     * @type {boolean}
     * @memberof CouponRestrictions
     */
    first_time_transaction?: boolean;
    /**
     * Minimum quantity of items on order required to redeem this coupon. (e.g., an order must have 2 items or more to work).
     * @type {number}
     * @memberof CouponRestrictions
     */
    minimum_items?: number;
    /**
     * 
     * @type {RestrictionsMinimumAmount}
     * @memberof CouponRestrictions
     */
    minimum_amount?: RestrictionsMinimumAmount;
    /**
     * A positive integer specifying the number of times the coupon can be redeemed before it's no longer valid. For example, you might have a 50% off coupon that the first 20 customers can use.
     * @type {number}
     * @memberof CouponRestrictions
     */
    max_redemptions?: number;
    /**
     * A value indicating if the coupon can only be redeemed for customers once.
     * @type {boolean}
     * @memberof CouponRestrictions
     */
    limit_customer?: boolean;
    /**
     * A list of membership package ids that a customer must have an active membership to redeem coupon.
     * @type {Array<string>}
     * @memberof CouponRestrictions
     */
    membership_packages?: Array<string>;
}

export function CouponRestrictionsFromJSON(json: any): CouponRestrictions {
    return CouponRestrictionsFromJSONTyped(json, false);
}

export function CouponRestrictionsFromJSONTyped(json: any, ignoreDiscriminator: boolean): CouponRestrictions {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'first_time_transaction': !exists(json, 'first_time_transaction') ? undefined : json['first_time_transaction'],
        'minimum_items': !exists(json, 'minimum_items') ? undefined : json['minimum_items'],
        'minimum_amount': !exists(json, 'minimum_amount') ? undefined : RestrictionsMinimumAmountFromJSON(json['minimum_amount']),
        'max_redemptions': !exists(json, 'max_redemptions') ? undefined : json['max_redemptions'],
        'limit_customer': !exists(json, 'limit_customer') ? undefined : json['limit_customer'],
        'membership_packages': !exists(json, 'membership_packages') ? undefined : json['membership_packages'],
    };
}

export function CouponRestrictionsToJSON(value?: CouponRestrictions | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'first_time_transaction': value.first_time_transaction,
        'minimum_items': value.minimum_items,
        'minimum_amount': RestrictionsMinimumAmountToJSON(value.minimum_amount),
        'max_redemptions': value.max_redemptions,
        'limit_customer': value.limit_customer,
        'membership_packages': value.membership_packages,
    };
}

